// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rsgRO","name":"styles_name__31Vrt","phone":"styles_phone__2ofm4"};